import api from 'shared/api'

const FETCH_REQUEST = 'nfps/FETCH_REQUEST'
const FETCH_SUCCESS = 'nfps/FETCH_SUCCESS'
const FETCH_NFP_SUCCESS = 'nfps/FETCH_NFP_SUCCESS'
const FETCH_FAILURE = 'nfps/FETCH_FAILURE'

const FETCH_REPORT_REQUEST = 'nfps/FETCH_REPORT_REQUEST'
const FETCH_COMPANY_REPORT_SUCCESS = 'nfps/FETCH_COMPANY_REPORT_SUCCESS'
const FETCH_REPORT_FAILURE = 'nfps/FETCH_REPORT_FAILURE'

const initialState = {
  nfps: [],
  loadedNfps: [],
  total_size: 0,
  loadedIds: [],
  loaded: false,
  loading: false,
  loadingReport: false,
  errors: [],
  reportData: {},
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchNfpSuccess(payload) {
  return {
    type: FETCH_NFP_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function fetchReportRequest(payload = {}) {
  return {
    type: FETCH_REPORT_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchReportSuccess(payload) {
  return {
    type: FETCH_COMPANY_REPORT_SUCCESS,
    payload,
  }
}

export function fetchReportFailure(errors = []) {
  return {
    type: FETCH_REPORT_FAILURE,
    errors,
  }
}

export function loadNfp(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.nfps.loadedIds ? state.nfps.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }))

    return api(`api/v1/nfps/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchNfpSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function loadNfpReport(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = state.nfps.loadedIds ? state.nfps.loadedIds.slice() : []
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchReportRequest({ loadedIds }))

    return api(`api/v1/nfps/${id}/report`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchReportSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchReportFailure(errors))
        })
      })
  }
}

export function loadNfps(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api('api/v1/nfps', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        total_size: payload.total_size,
        nfps: [...payload.result]
      })
    case FETCH_NFP_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedNfps: [
          ...state.loadedNfps,
          payload
        ]
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    case FETCH_REPORT_REQUEST:
      return Object.assign({}, state, {
        loadingReport: true,
        loadedIds: action.loadedIds || state.loadedIds,
      })
    case FETCH_COMPANY_REPORT_SUCCESS:
      return Object.assign({}, state, {
        loadingReport: false,
        errors: [],
        reportData: {
          ...payload
        },
      })
    case FETCH_REPORT_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loadingReport: false,
        errors,
      })
    default:
      return state
  }
}

